import { __ } from '@wordpress/i18n';
const { useState } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, PanelRow, TextControl, ToggleControl } = wp.components;

export default ({ attributes, setAttributes, setSideTextPreview }) => {
  const [shouldShowSideText, setShowSideText] = useState(attributes.showSideText);

  function handleShowSideTextChange(showSideText) {
    setAttributes({ showSideText })
    setShowSideText(showSideText)
  }

  function handleSideTextChange(sideText) {
    setSideTextPreview(sideText)
    setAttributes({ sideText })
  }

  return (
    <InspectorControls>
      <PanelBody
        title={__("Opções de exibição")}
        initialOpen={true}
      >
        <PanelRow>
          <ToggleControl
            label={__("Exibir texto lateral")}
            checked={attributes.showSideText}
            onChange={handleShowSideTextChange}
          />
        </PanelRow>
        {shouldShowSideText && (
          <PanelRow>
            <TextControl
              label={__("Texto lateral do campo")}
              value={attributes.sideText}
              onChange={handleSideTextChange}
            />
          </PanelRow>
        )}
      </PanelBody>

      <PanelBody
        title={__("Controle do campo")}
        initialOpen={false}
      >
        <PanelRow>
          <TextControl
            label={__("ID do campo")}
            value={attributes.fieldId}
            onChange={(fieldId) => setAttributes({ fieldId })}
          />
        </PanelRow>
      </PanelBody>
    </InspectorControls>
  )
}
